import React, { useEffect, useMemo, useState } from "react";

import { useFilters } from "@/providers/FiltersProvider";
import { ICommonFilter, IMainFilterChildren } from "@/types/Filters";

import FilterSearchInput from "./FilterSearchInput";

interface IMultiCheckbox {
    data: IMainFilterChildren
}
function MultiCheckbox({ data }: IMultiCheckbox) {
    const [searchText, setSearchText] = useState("");
    const { tempFilters, setTempFilters } = useFilters();
    const [selectedItem, setSelectedItem] = useState<ICommonFilter[]>([]);

    useEffect(() => {
        const f = tempFilters?.[data.id];
        if (f) {
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setSelectedItem(f.data);
        }
    }, [data.id, tempFilters]);

    const filterData: ICommonFilter[] = useMemo(() => {
        if (data.data) {
            return data.data;
        }
        return [];
    }, [data.data]);

    const handleOnChange = (item: ICommonFilter) => {
        setSelectedItem(p => {
            let t = [];
            if (p.find(i => i.value === item.value)) {
                t = p.filter((i: ICommonFilter) => i.value !== item.value);
            } else {
                t = [...p, {
                    label: item.label,
                    value: item.value,
                }];
            }
            if (data?.dependsOn) {
                data?.dependsOn.forEach(i => {
                    if (tempFilters[i]) {
                        delete tempFilters[i];
                    }
                });
            }
            setTempFilters({
                ...tempFilters,
                [data.id]: {
                    data: t,
                    all: t.length === filterData.length,
                },
            });
            return t;
        });
    };

    const filterListBySearchText = useMemo(() => {
        return filterData.filter(i => i.label.toLowerCase().includes(searchText.toLowerCase()));
    }, [filterData, searchText]);

    const handleAllOnChange = () => {
        let t = { ...tempFilters };
        if (selectedItem?.length < filterData.length) {
            t = {
                ...tempFilters,
                [data.id]: {
                    data: filterData,
                    all: true,
                },
            };
            setTempFilters(t);
        } else {
            setSelectedItem([]);
            delete t[data.id];
        }
        if (data?.dependsOn) {
            data?.dependsOn.forEach(i => {
                if (t[i]) {
                    delete t[i];
                }
            });
        }
        setTempFilters(t);
    };

    return (
        <div className='checkBoxItems'>
            {
                data.hasSearch
                && <FilterSearchInput
                    setValue={setSearchText} />
            }
            <div className={`checkBox ${selectedItem?.length > 0 && selectedItem?.length < filterData.length ? "indeterminate" : ""}`}>
                <input
                    type="checkbox"
                    id="all"
                    checked={selectedItem?.length > 0}
                    onChange={handleAllOnChange} />
                <label htmlFor={"all"}>All</label>
            </div>
            <div className="checkBoxItemCont">
                {
                    filterListBySearchText.map((item) => (
                        <div className='checkBox' key={item.id}>
                            <input
                                type="checkbox"
                                id={item.label + item.value}
                                name={item.label}
                                value={item.value}
                                key={item.value}
                                checked={!!selectedItem?.find(i => i.value === item.value)}
                                onChange={() => handleOnChange(item)} />
                            <label htmlFor={item.label + item.value}>{item.label}</label>
                        </div>
                    ))
                }
            </div>
        </div>
    );
}

export default MultiCheckbox;
